import { useListPresalesEngineersForAccountQuery } from "@generated";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useEffect, useState } from "react";
import { PresalesEngineer } from "../types";
import { generated } from "@generated";
import { AppDispatch } from "@store/*";

const useGetAllPresalesEngineers = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const dispatch = useDispatch<AppDispatch>();
  const { data, isLoading, error } = useListPresalesEngineersForAccountQuery({
    slug: accountSlug,
    page: {},
  });
  const [presalesEngineers, setPresalesEngineers] = useState<
    PresalesEngineer[]
  >([]);
  const [loading, setLoading] = useState(isLoading);

  useEffect(() => {
    if (!isLoading && data && data.data && data.meta && !error) {
      setPresalesEngineers(
        data.data.map((engineer) => ({
          id: engineer.id?.toString() || "",
          name: engineer.attributes?.name || "",
        }))
      );
      const pageCount = data.meta["page-count"] || 1;

      if (pageCount > 1) {
        setLoading(true);
        const fetchPages = async () => {
          try {
            for (let page = 2; page <= pageCount; page++) {
              // Trigger additional fetches for each page
              const resultAction = await dispatch(
                generated.endpoints.listPresalesEngineersForAccount.initiate({
                  slug: accountSlug,
                  page: {
                    number: page,
                  },
                })
              ).unwrap(); // Assuming this is where the 'unwrap()' method is now chained

              // Check if resultAction.data exists and is an array before mapping
              if (resultAction.data && Array.isArray(resultAction.data)) {
                setPresalesEngineers((preEngineers) => [
                  ...preEngineers,
                  ...resultAction.data!.map((engineer) => ({
                    id: engineer.id?.toString() || "",
                    name: engineer.attributes?.name || "",
                  })),
                ]);
              }
            }
          } catch (err) {
            console.error("Failed to fetch additional pages:", err);
          } finally {
            setLoading(false);
          }
        };

        fetchPages();
      }
    }
  }, [data, isLoading, error, accountSlug, dispatch]);

  return { presalesEngineers, loading, error };
};

export default useGetAllPresalesEngineers;
